export default __webpack_public_path__ + "static/tim-bitmoji-7dc5c9949e1b1ea9669f32d1ce81449a.png";